import React, { useContext, useEffect, useMemo, useState } from 'react';
import {HeaderPrice} from './HeaderPrice';
import {HeaderUser} from './HeaderUser';
import {images} from 'assets/img/dashboard/layout/header';
import 'assets/sass/dashboard/layout/Header.scss';
import 'assets/sass/common/Select.scss';
import {Link} from "react-router-dom"
import {app} from "app/app";
import {Select} from 'components/common/Select';
import { AppContext } from 'app/state/AppContext';


export function Header() {
    const { currencies } = useContext(AppContext);
    const [selectedCurrency, setSelectedCurrency] = useState();

    const sortedCurrencies = useMemo(() => {
        return [
            ...currencies.filter(currency => currency.isFiat()).reverse(),
            ...currencies.filter(currency => currency.isCoin()),
        ];
    }, [currencies]);

    useEffect(() => {
        if (sortedCurrencies.length) {
            setSelectedCurrency(sortedCurrencies[0].lowercaseCode());
        }
    }, [sortedCurrencies]);


    const selectChoices = useMemo(() => {
        return Object.fromEntries(
            sortedCurrencies.map((currency) => {
                return ([
                    currency.lowercaseCode(), {name: `${currency.asVerbose(true, true)} (${currency.code()})`
                }]);
            })
        );
    }, [sortedCurrencies]);

    function renderSelect() {
        return selectedCurrency && !!Object.keys(selectChoices).length && <Select
            value={selectedCurrency}
            data={selectChoices}
            onSelect={(name, value) => setSelectedCurrency(value)}
            placeholder="Ver cotización de"
            className="header-select"
        />
    }

    return <header className="dashboard-header">
        <Link to={app.routes().index}>
            <figure className="dashboard-header--logo">
                <img className="d-none d-md-block" src={images.logo} alt="Dashboard"/>
                <img className="d-block d-md-none" src={images.logoMobile} alt="Dashboard"/>
            </figure>
        </Link>
        {renderSelect()}
        <div className="dashboard-header--nav">
            <HeaderPrice selectedCurrency={selectedCurrency} />
            <HeaderUser/>
        </div>
    </header>
}
